export const mapDemographicLabels = {
  age: 'Age',
  gender: 'Gender',
  country: 'Country',
  generation: 'Generation',
  race: 'Race',
  metro_area: 'Metro Area',
  education: 'Education',
  ethnicity: 'Ethnicity',
  relationship_status: 'Relationship Status',
  has_children: 'Presence of Children',
  language: 'Language',
  household_income: 'Household Income',
  employment_status: 'Employment Status',
  county_type: 'County type',
  job_function: 'Job Function',
  region: 'Region',
  state: 'State',
  presence_of_children: 'Presence Of Children',
  area_of_employment: 'Area Of Employment',
  BARB_regions: 'Region',
  uk_ethnicity: 'Ethnicity',
  uk_country: 'Country',
  social_classification: 'Social Class',
};

export const mapDemographicIcons = {
  age: 'age',
  gender: 'gender',
  country: 'country',
  generation: 'generation',
  race: 'race',
  metro_area: 'metro area',
  education: 'education',
  relationship_status: 'relationship status',
  has_children: 'presence of children',
  language: 'language',
  household_income: 'household income',
  employment_status: 'employement status',
  county_type: 'county type',
  job_function: 'job function',
  region: 'region',
  presence_of_children: 'presence of children',
  area_of_employment: 'job function',
  BARB_regions: 'metro area',
  uk_ethnicity: 'race',
  uk_country: 'uk_map',
  social_classification: 'household income',
};
